import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ImpressumComponent from '../components/Impressum/ImpressumComponent';
import Titles from '../components/Titles/Titles';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const Impressum = () => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const seo = usePageSEO('impressum');

    useEffect(() => {
        if (i18n.language !== 'de') {
            navigate(`/${i18n.language}`, { replace: true });
        }
    }, [i18n.language, navigate]);

    if (i18n.language !== 'de') {
        return null;
    }

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <Titles pageType="impressum"/>
            <ImpressumComponent type="impressum" />
        </>
    );
};

export default Impressum;